<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PRCYTy/tc-custom/9781398435285.jpg?1705539859498" alt="This image is the cover for the book Gas Meter Knees"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gas Meter Knees
      </h1>
      <p class="bookDescription body article font2">
        <p>“It wasn’t until I was 13 that I realised pressing 50 pence pieces into Plasticine sheets and filling the impressions with water, freezing overnight and quickly using the ice coins in the electric meter slots wasn’t normal behaviour.” From raiding the bins of London fashion labels, to being asked to bury dead bodies in a flyover, being beaten unconscious twice in one day, to regularly driving my inebriated maths teacher back to school for a fee, finding my boss dead in a mysterious suicide and dragging a teetering motorcyclist to safety on a busy A3 flyover to avoid certain death, the weekly war with the bailiffs doggedly trying to repossess my TV, and finally an attempt to emulate Evel Knievel by jumping a pickup truck in Wimbledon Stadium. I learned the hard way that nobody was going to save me except myself – all this before the age of 16. A real-life rags-to-relative-affluence story which takes us from humble SW17 origins to the bustling streets of Singapore and Tokyo. The story is as diverse and delightfully absurd as it gets. If I hadn’t lived every moment, I wouldn’t believe it either.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francis Fox
      </h2>
      
      <p class="authorDescription body article">“Every day you have a choice – be part of the problem or part of the solution.” Francis fox was born in 1973 and was raised in ‘the dodgy end’ of South London. Growing up he was highly motivated to improve his life experiences, and these early lessons forged his career as a management consultant and business turnaround expert. He has lived and worked around the world, stationed in Singapore, Thailand, Vietnam, Japan and Italy amongst others. A keen cyclist and with a strong penchant for Asian cuisine, he now shares his time with his family between Australia, Japan and the family home in Thailand along with five rescue cats (and counting). An Italian speaker and a student of Japanese currently, he is always looking to learn about new cultures and customs and this vibe has passed down to his children. Gas Meter Knees is his first book and it’s a rollercoaster ride through his formative years in 1980’s London that will make you laugh, cry and lots in between ‘sometimes you’re the pigeon – sometimes you’re the statue’.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1716537c